import React,{useState, useEffect} from 'react';
import Header from '../JobPage/Header';
import Footer from '../JobPage/Footer';
import JobFilters from './JobFilters';
import SearchBar from '../JobPage/SearchBar';
import { useNavigate } from 'react-router-dom';
import useCompanies from '../Hooks/useCompanies';
import Pagination from '../JobPage/Pagination';
import { Container } from '../Components/ui/container';
import { Stack, Inline } from '../Components/ui/layout';
import { Card, CardContent } from '../Components/ui/card';
import { Heading, Text } from '../Components/ui/typography';
import { Button } from '../Components/ui/button';

const ExploreCompanies = () => {

  // <img
  //         src="https://cdn.builder.io/api/v1/image/assets/TEMP/b6841b2f6cd30a70ac58e18a391545b5bec6e28fb91aa3f63be0fb92efb5e568?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f"
  //         alt="Company logo"
  //         className="explore-company-logo"
  //       />

  const navigate = useNavigate();
  const companyData = useCompanies();
  // Debug log removed — was leaking company list to console.
  const handleViewMoreClick = (companyId) => {
    navigate(`/tempoverview/${companyId}`);
  };


  const CompanyCard = ({ company }) => (
    <Card className="hover:shadow-lg transition-shadow">
      <CardContent className="p-lg">
        <Stack spacing="md">
          <Heading level="h3" className="text-xl md:text-2xl">
            {company.companyName}
          </Heading>
          <Text size="base" variant="muted" className="line-clamp-3">
            {company.aboutUs}
          </Text>
          <Inline spacing="md" className="flex-wrap">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/51bab7189fce9025d705ab2b3980269e2d036f67f15aa7fd126ade52dc64b130?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f"
                alt="Location icon"
                className="w-4 h-4"
              />
              <span>{company.mapLocation}</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/273f2ca717a2b7fb9d417df57ba7d4d31f9c2cc58a1e05d75c16a0320eb15a74?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f"
                alt="Company type icon"
                className="w-4 h-4"
              />
              <span>{company.organizationType}</span>
            </div>
            <div className="text-sm text-muted-foreground">
              {company.industryType}
            </div>
          </Inline>
          <Button 
            variant="default" 
            onClick={() => handleViewMoreClick(company.id)}
            className="w-full md:w-auto"
          >
            View More
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );


  const [currentPage, setCurrentPage] = useState(1);
  const companiesPerPage = 5;
  const indexOfLastJob = currentPage * companiesPerPage;
  const indexOfFirstJob = indexOfLastJob - companiesPerPage;
  const currentJobs = companyData.slice(indexOfFirstJob, indexOfLastJob);


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <SearchBar />
      <Container>
        <Inline spacing="lg" align="start" className="py-lg flex-col md:flex-row">
          <JobFilters />
          <Stack spacing="md" className="flex-1 w-full">
            {currentJobs.map((company, index) => (
              <CompanyCard key={index} company={company} />
            ))}
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(companyData.length / companiesPerPage)}
              onPageChange={handlePageChange}
            />
          </Stack>
        </Inline>
      </Container>
      <Footer />
    </div>
  );
};

export default ExploreCompanies;
